<script lang="ts">
  import { fade } from "svelte/transition";
  import OVIcon from "$components/+shared/OVIcon/OVIcon.svelte";
  import { RelatedItemThin } from "app/components/+shared/OVIcon";
</script>

<div class="my-12 flex flex-col items-center justify-center" in:fade|global={{ duration: 80 }}>
  <OVIcon
    icon={RelatedItemThin}
    size="size-[75px]"
    class="text-neutral-400 dark:text-neutral-500"
  />
  <div class="mt-2 flex items-center gap-1">
    <span class="text-sm font-medium text-neutral-500 dark:text-neutral-300">
      No related Items
    </span>
  </div>
  <span class="mt-2 text-center text-xs text-neutral-500/60 dark:text-neutral-400">
    Semantically related items will <br /> appear here
  </span>
</div>
